var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-menu__link",on:{"click":_vm.trigger_click}},[(_vm.menu.icon)?_c('i',{staticClass:"kt-menu__link-icon",class:_vm.menu.icon}):_vm._e(),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v(_vm._s(_vm.menu.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }